import React from 'react';

import Image from 'Components/Globals/Elements/Image';
import GeneralErrorImage from 'Assets/images/error/Error_general.json';
import Button from 'Components/Globals/Elements/Button';
import routes from 'Pages/router/constants/routes';
import { onCallToSupportTeam } from 'Helpers';

import styles from './styles.module.scss';

const ErrorPage = () => {
	const onNavigateToHome = () => {
		window.open(`/pwa${routes.dashboard}`, '_self');
	};

	return (
		<div className={`${styles.page}`}>
			<Image
				src={GeneralErrorImage}
				alt={'خطا'}
				width={188}
				height={210}
				className={`ml-24 mr-24`}
			/>
			<p
				className={`m-24 sm txt-text-gray ws-pre-wrap text-center ${styles.page__description}`}
			>{`متاسفانه خطایی رخ داد.\nما از بروز این خطا آگاهیم.\nتیم تخفیفان به زودی مشکل را برطرف خواهد کرد`}</p>
			<Button
				label={'بازگشت به صفحه اصلی'}
				onClick={onNavigateToHome}
				className={'mt-24'}
			/>
			<Button
				label={'تماس با پشتیبانی'}
				onClick={onCallToSupportTeam}
				variant={'outline'}
				className={`mt-16`}
			/>
		</div>
	);
};

export default ErrorPage;
